import { useState, useEffect } from "react";
import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";

const spinnerVariants = cva("animate-spin transition-opacity", {
    variants: {
        variant: {
            primary: "text-darkgreen-500",
            secondary: "text-darkgreen-500",
        },
        size: {
            default: "h-8 w-8",
            sm: "h-4 w-4",
            lg: "h-16 w-16",
            xl: "h-24 w-24",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "default",
    },
});

export const Spinner = ({ delay = 300, size, variant, className }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    return (
        <div
            className={cn(
                "transition-opacity",
                visible ? "opacity-100" : "opacity-0",
            )}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={cn(
                    spinnerVariants({
                        variant,
                        size,
                        className,
                    }),
                )}
            >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            <span className="sr-only">Loading</span>
        </div>
    );
};
